import {getItem, setItem, removeItem, isFake} from "@/utils/storage";

const STORE_NAME = "uw_local_config";

const save = (config) => {
	setItem(STORE_NAME, config);
};

const load = () => {
	let config = null;

	if (isFake()) {
		console.warn("[Demo]: Local storage inaccessible. Won't be able to persist config changes");
	}
	else {
		const persisted = getItem(STORE_NAME);

		if (persisted) {
			try {
				config = JSON.parse(persisted);
			}
			catch (ex) {
				removeItem(STORE_NAME);
			}
		}
	}

	return config;
};

export {
	save,
	load,
};
